import React from 'react'
import { Select } from '../common/Select'
import { ErrorMessage } from '../common/ErrorMessage'
import { VEHICLE_VALUES } from './constants'

interface Props {
  name:string,
  value: string | number,
  onChange: (e: React.ChangeEvent<any>) => void,
  onBlur?: (e: React.FocusEvent<any>) => void,
  placeholder?: string,
  error?: boolean,
  errorMessage?: string,
}

const VehicleValue:  React.FC<Props> = ({
name,
value,
onChange,
onBlur,
placeholder = 'Select estimated vehicle value',
error,
errorMessage,
}) => {
    return (
      <>
        {error && <ErrorMessage id={`${name}Error`}>{errorMessage}</ErrorMessage>}
        <Select
          id='VehicleValue'
          options={VEHICLE_VALUES}
          name={name}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          error={error}
          myRef={undefined}
          style={{}}
          tinyGap={(0)}
          onBlur={onBlur}
        />
      </>
    )
}

export default VehicleValue